

























































import { Component, Vue, Watch } from 'vue-property-decorator';
import notificationService from '@/services/notificationService';
import EventLogsTable from '@/modules/shared/eventlogs/components/EventLogsTable.vue';
import machineriesRepository from '@/modules/machinery/services/machineriesRepository';
import { EventLogsObjectType } from '@/modules/shared/eventlogs/enums';
import { DxTabs } from 'devextreme-vue';
import {
  DxForm,
  DxSimpleItem,
  DxRequiredRule,
  DxGroupItem,
  DxLabel,
} from 'devextreme-vue/form';
import cCard from '@/components/default/Card.vue';
import Machinery from '@/modules/machinery/classes/Machinery';
import machineryEventsTable from '@/modules/machinery/components/machineryEventsTable.vue';
import MachineryRentalsTable from '@/modules/machinery/components/MachineryRentalsTable.vue';
import MachineryRentalPopup from '@/modules/machinery/components/MachineryRentalPopup.vue';

import machineryEventTypesRepository from '@/modules/machinery/services/machineryEventTypesRepository';
import machineryStatusRepository from '@/modules/machinery/services/machineryStatusRepository';

import customersRepository from '@/services/customers/customersRepository';
import dxCustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import MachineryProfile from '@/modules/machinery/classes/MachineryProfile';

import SaveBar from '@/modules/shared/savebar/SaveBar.vue';
import _ from 'lodash';
import FileManager from '@/modules/documents/FileManager.vue';
import { ContactsClient, ContactsLookupQuery, DataSourceLoadOptionsBase } from '@/data/web-api-client';

@Component({
  components: {
    cCard,
    DxForm,
    DxSimpleItem,
    DxRequiredRule,
    DxGroupItem,
    DxLabel,
    DxTabs,
    SaveBar,
    machineryEventsTable,
    EventLogsTable,
    MachineryRentalsTable,
    MachineryRentalPopup,
    FileManager,
  },
})
export default class MachineryDetailPage extends Vue {
  private loading: boolean = false;
  private saving: boolean = false;
  private item: Machinery = new Machinery();
  private navIndex: number = 0;
  private profile: MachineryProfile = new MachineryProfile();
  private eventTypes: IMachineryEventType[] = [];
  private machineryStatus: IMachineryStatus[] = [];

  private mounted() {
    this.loadData();
    this.loadStatus();
    this.loadEventTypesAsync();
  }

  private refreshMachineryRentalsTable() {
    (this.$refs.MachineryRentalsTable as MachineryRentalsTable).refresh();
  }

  private async loadStatus() {
    try {
      this.machineryStatus = (await machineryStatusRepository.getAll()).data;
    } catch (err) {
      // Do nothing
    }
  }

  private async loadData() {
    try {
      this.loading = true;
      await this.item.init(this.$route.params.id);
      if (this.item.profileId) {
        this.loadProfile(this.item.profileId);
      }
    } catch (err) {
      notificationService.failedToLoad();
    } finally {
      this.loading = false;
    }
  }

  private async loadProfile(id: string) {
    this.profile.init(id);
  }

  private async loadEventTypesAsync() {
    this.eventTypes = (await machineryEventTypesRepository.getAll()).data;
  }

  private add() {
    switch (this.navIndex) {
      case 2:
        (this.$refs.machineryEventsTable as machineryEventsTable).add();
        break;
      case 3:
        (this.$refs.MachineryRentalPopup as MachineryRentalPopup).add();
        break;
    }
  }

  get navbarItems() {
    return [
      { icon: 'fas fa-info-circle', text: 'Data'},
      { icon: 'fas fa-folder', text: 'Documenten'},
      { icon: 'fas fa-bell', text: 'Events'},
      { icon: 'fas fa-calendar-alt', text: 'Verhuur'},
      { icon: 'fas fa-history', text: 'Geschiedenis'},
    ];
  }

  get historyConfig(): IEventLogQuery {
    return {
      objectId: this.id,
      type: EventLogsObjectType.Machinery,
    };
  }

  get objectType() {
    return EventLogsObjectType.Machinery;
  }

  get customersOptions() {
    const self = this;
    const client = (new ContactsClient(undefined, this.$axios));
    return {
      dataSource: new DataSource({
        store: new dxCustomStore({
            key: 'id',
            load: async (loadOptions) => {
            if (loadOptions.filter) {
                loadOptions.filter = undefined;
            }
            if (loadOptions.searchExpr && loadOptions.searchOperation && loadOptions.searchValue) {
                loadOptions.filter = [['displayName', loadOptions.searchOperation, loadOptions.searchValue],
                'or',
                ['email', loadOptions.searchOperation, loadOptions.searchValue]];
            }

            const res =  await client.lookupContacts(new ContactsLookupQuery({
                projectId: undefined,
                options: new DataSourceLoadOptionsBase(Object.assign({}, loadOptions, {
                  stringToLower: true,
                })),
            }));

            return res;
          },
          byKey: async (val: string) => {
            return await client.getBasicInfo(val);
          },
        }),
        paginate: true,
      }),
      displayExpr: 'displayName',
      valueExpr: 'id',
      searchEnabled: true,
      showClearButton: true,
    };
  }

  get statusOptions() {
    const self = this;
    return {
      dataSource: this.machineryStatus,
      displayExpr: 'name',
      valueExpr: 'id',
      searchEnabled: true,
    };
  }

  get formLayout() {
    return {
      BasicFields: [
        {
          itemType: 'simple',
          dataField: 'internalNumber',
          label: {
            text: this.$t('objects.machinery.fields.InternalNumber'),
          },
        },
        {
          itemType: 'simple',
          dataField: 'statusId',
          editorOptions: this.statusOptions,
          editorType: 'dxSelectBox',
          label: {
            text: 'Status',
          },
        },
        {
          itemType: 'simple',
          dataField: 'location',
          label: {
            text: 'Locatie',
          },
        },
        {
          itemType: 'simple',
          dataField: 'licensePlate',
          label: {
            text: this.$t('objects.machinery.fields.LicensePlate'),
          },
        },
        {
          itemType: 'simple',
          dataField: 'brand',
          label: {
            text: this.$t('objects.machinery.fields.Brand'),
          },
        },
        {
          itemType: 'simple',
          dataField: 'type',
          label: {
            text: this.$t('objects.machinery.fields.Type'),
          },
        },
        {
          itemType: 'simple',
          dataField: 'serialNumber',
          label: {
            text: this.$t('objects.machinery.fields.SerialNumber'),
          },
        },
        {
          itemType: 'simple',
          dataField: 'color',
          label: {
            text: this.$t('objects.machinery.fields.Color'),
          },
        },
        {
          itemType: 'simple',
          dataField: 'constructionYear',
          editorType: 'dxNumberBox',
          label: {
            text: this.$t('objects.machinery.fields.ConstructionYear'),
          },
        },
      ],
      PurchaseFields: [
        {
          itemType: 'simple',
          dataField: 'supplierId',
          editorOptions: this.customersOptions,
          editorType: 'dxSelectBox',
          label: {
            text: this.$t('objects.machinery.fields.Supplier'),
          },
        },
        {
          itemType: 'simple',
          dataField: 'purchaseDate',
          editorOptions: { width: '100%', useMaskBehavior: true },
          editorType: 'dxDateBox',
          label: {
            text: this.$t('objects.machinery.fields.PurchaseDate'),
          },
        },
        {
          itemType: 'simple',
          dataField: 'listPrice',
          editorType: 'dxNumberBox',
          label: {
            text: this.$t('objects.machinery.fields.ListPrice'),
          },
        },
        {
          itemType: 'simple',
          dataField: 'purchaseValue',
          editorType: 'dxNumberBox',
          label: {
            text: this.$t('objects.machinery.fields.PurchaseValue'),
          },
        },
        {
          itemType: 'simple',
          dataField: 'residualValue',
          editorType: 'dxNumberBox',
          label: {
            text: this.$t('objects.machinery.fields.ResidualValue'),
          },
        },
      ],
    };
  }

  get customFields() {
    const fields: any = [];

    if (this.profile && this.profile.fields) {
      this.profile.fields.forEach((field) => {
        if (field.type === 0) {
          fields.push({
            itemType: 'simple',
            dataField: 'customProperties.' + field.name,
            label: {
              text: field.name,
            },
          });
        }

        if (field.type === 1) {
          fields.push({
            itemType: 'simple',
            editorType: 'dxNumberBox',
            dataField: 'customProperties.' + field.name,
            label: {
              text: field.name,
            },
          });
        }

        if (field.type === 2) {
          fields.push({
            itemType: 'simple',
            dataField: 'customProperties.' + field.name,
            editorOptions: { width: '100%', useMaskBehavior: true },
            editorType: 'dxDateBox',
            label: {
              text: field.name,
            },
          });
        }
      });
    }

    return fields;
  }

  get eventGridColumns() {
    return [
      {
        caption: this.$t('objects.MachineryEventTypes.fields.Icon'),
        cellTemplate: (cellElement: any, cellInfo: any) => {
          if (cellInfo.data.type) {
            return $(cellElement).append(`<i class='fas ${cellInfo.data.type.icon}'></i> ${cellInfo.data.type.name}`);
          }
          return cellElement;
        },
      },
      {
        dataField: 'eventId',
        caption: this.$t('objects.MachineryProfiles.fields.Id'),
      },
      {
        dataField: 'title',
        caption: this.$t('objects.machineryEvent.fields.Title'),
      },
      {
        dataField: 'date',
        caption: this.$t('objects.machineryEvent.fields.Date'),
        dataType: 'date',
      },
      {
        dataField: 'price',
        caption: this.$t('objects.machineryEvent.fields.Price'),
        format: {
          type: 'currency',
          precision: 2,
        },
        alignment: 'left',
      },
      {
        dataField: 'operatingHours',
        caption: this.$t('objects.machineryEvent.fields.OperatingHours'),
        alignment: 'left',
      },
      {
        type: 'buttons',
        buttons: ['delete'],
      },
    ];
  }

  get id() {
    return this.$route.params.id;
  }
}
